module.exports = "<h2>\n  {{title}}\n</h2>\n<div>\n  <ng-content></ng-content>\n</div>\n"